"use client";

import { cn } from "@/lib/utils";

interface Props {
  hasElevator: boolean;
  floor: number;
  carryHelp?: boolean;
  floorPlaceholder?: string;
  onElevatorChange: (has: boolean) => void;
  onFloorChange: (floor: number) => void;
  onCarryHelpChange?: (help: boolean) => void;
  attempted?: boolean;
  carryHelpRequired?: boolean;
}

export default function Step2ElevatorSelect({
  hasElevator,
  floor,
  carryHelp,
  floorPlaceholder = "물품 운반 경로에 있는 계단 층수를 선택해주세요",
  onElevatorChange,
  onFloorChange,
  onCarryHelpChange,
  attempted = false,
  carryHelpRequired = false,
}: Props) {
  const floorError = attempted && floor === -99;
  const carryHelpError = attempted && carryHelpRequired && !carryHelp;
  return (
    <div className="space-y-3">
      {/* 운반 도움 가능 */}
      {onCarryHelpChange && (
        <div>
          <label
            className={cn(
              'flex items-center gap-2 cursor-pointer rounded',
              carryHelpError && 'p-2 border border-red-500 ring-2 ring-red-200',
            )}
          >
            <input
              type="checkbox"
              checked={carryHelp || false}
              onChange={(e) => onCarryHelpChange(e.target.checked)}
              className="rounded border-gray-300"
            />
            <span className={cn('text-sm', carryHelpError ? 'text-red-600 font-medium' : 'text-gray-600')}>
              운반 도움 가능
              {carryHelpRequired && <span className="text-red-500 ml-0.5">*</span>}
            </span>
          </label>
          {carryHelpError && (
            <p className="text-sm text-red-500 mt-1">선택하신 물품에는 운반 도움이 필요합니다</p>
          )}
        </div>
      )}

      {/* 엘리베이터 이용 가능 */}
      <div>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={hasElevator}
            onChange={(e) => onElevatorChange(e.target.checked)}
            className="rounded border-gray-300"
          />
          <span className="text-sm text-gray-600">엘리베이터 이용 가능 (크기 확인)</span>
        </label>
        {/* <p className="text-xs text-gray-500 mt-1 ml-6">
          물품이 엘리베이터에 들어가지 않으면 현장에서 배송이 취소될 수 있습니다.
        </p> */}
      </div>

      {/* 층수 선택 — 엘리베이터 유무와 관계없이 항상 입력 (할증 계산용) */}
      <div className="space-y-2">
        <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
          <p className="text-xs text-amber-800 font-medium leading-relaxed">
            1층이거나 엘리베이터가 있어도 차량에서 운반 위치까지 계단이 있을 경우 계단 층수를 선택해주세요.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <label className="text-sm text-gray-600 whitespace-nowrap">
            운반 계단 층수
            <span className="text-red-500 ml-0.5">*</span>
          </label>
          <select
            value={String(floor)}
            onChange={(e) => onFloorChange(Number(e.target.value))}
            className={cn(
              'flex-1 px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#1A3A5C]',
              floorError && 'border-red-500 ring-2 ring-red-200',
            )}
          >
            <option value="-99" disabled>{floorPlaceholder}</option>
            <option value="0">없음 (3칸 이하)</option>
            <option value="0.5">0.5층 (10칸 이하)</option>
            <option value="1">1층</option>
            <option value="1.5">1.5층</option>
            <option value="2">2층</option>
            <option value="2.5">2.5층</option>
            <option value="3">3층</option>
            <option value="3.5">3.5층</option>
            <option value="4">4층</option>
            <option value="4.5">4.5층</option>
            <option value="5">5층</option>
            <option value="-10">모름 (배송후정산)</option>
          </select>
        </div>
        {floorError && (
          <p className="text-sm text-red-500">운반 계단 층수를 선택해주세요</p>
        )}
      </div>
    </div>
  );
}
